import React from "react";

import styled, { keyframes } from "styled-components";
import { LoadingIcon2 } from "icons";

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    12.5% {
        transform: rotate(45deg);
    }
    25% {
        transform: rotate(90deg);
    }
    37.5% {
        transform: rotate(135deg);
    }
    50% {
        transform: rotate(180deg);
    }
    62.5% {
        transform: rotate(225deg);
    }
    75% {
        transform: rotate(270deg);
    }
    87.50% {
        transform: rotate(315deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;
export const Loader = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 0px;
  display: flex;
  justify-content: center;
  svg {
    animation: ${spin} 2s linear infinite;
  }
`;
const Loading2: React.FC<any> = (rest) => {
  return (
    <Loader>
      <LoadingIcon2 {...rest} />
    </Loader>
  );
};

export default Loading2;
